"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    noticePlugin: ()=>notice_js_namespaceObject.noticePlugin,
    gatewayPlugin: ()=>gateway_js_namespaceObject.gatewayPlugin,
    durationPlugin: ()=>duration_js_namespaceObject.durationPlugin,
    cloudRequest: ()=>external_cloud_request_js_namespaceObject.cloudRequest,
    envPlugin: ()=>env_js_namespaceObject.envPlugin,
    addDomainIDHeaderPlugin: ()=>add_domain_id_header_js_namespaceObject.addDomainIDHeaderPlugin,
    jwtPlugin: ()=>jwt_js_namespaceObject.jwtPlugin,
    domainIDPlugin: ()=>domain_id_js_namespaceObject.domainIDPlugin,
    resourceAccountPlugin: ()=>index_js_namespaceObject.resourceAccountPlugin,
    responseHandlerPlugin: ()=>response_handler_js_namespaceObject.responseHandlerPlugin,
    formatResDataPlugin: ()=>extra_data_js_namespaceObject.formatResDataPlugin,
    localePlugin: ()=>locale_js_namespaceObject.localePlugin
});
const external_cloud_request_js_namespaceObject = require("./cloud-request.js");
const jwt_js_namespaceObject = require("./plugins/jwt.js");
const domain_id_js_namespaceObject = require("./plugins/domain-id.js");
const locale_js_namespaceObject = require("./plugins/locale.js");
const env_js_namespaceObject = require("./plugins/env.js");
const duration_js_namespaceObject = require("./plugins/duration.js");
const response_handler_js_namespaceObject = require("./plugins/response-handler.js");
const notice_js_namespaceObject = require("./plugins/notice.js");
const extra_data_js_namespaceObject = require("./plugins/extra-data.js");
const add_domain_id_header_js_namespaceObject = require("./plugins/add-domain-id-header.js");
const gateway_js_namespaceObject = require("./plugins/gateway.js");
const index_js_namespaceObject = require("./plugins/resource-account/index.js");
exports.addDomainIDHeaderPlugin = __webpack_exports__.addDomainIDHeaderPlugin;
exports.cloudRequest = __webpack_exports__.cloudRequest;
exports.domainIDPlugin = __webpack_exports__.domainIDPlugin;
exports.durationPlugin = __webpack_exports__.durationPlugin;
exports.envPlugin = __webpack_exports__.envPlugin;
exports.formatResDataPlugin = __webpack_exports__.formatResDataPlugin;
exports.gatewayPlugin = __webpack_exports__.gatewayPlugin;
exports.jwtPlugin = __webpack_exports__.jwtPlugin;
exports.localePlugin = __webpack_exports__.localePlugin;
exports.noticePlugin = __webpack_exports__.noticePlugin;
exports.resourceAccountPlugin = __webpack_exports__.resourceAccountPlugin;
exports.responseHandlerPlugin = __webpack_exports__.responseHandlerPlugin;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "addDomainIDHeaderPlugin",
    "cloudRequest",
    "domainIDPlugin",
    "durationPlugin",
    "envPlugin",
    "formatResDataPlugin",
    "gatewayPlugin",
    "jwtPlugin",
    "localePlugin",
    "noticePlugin",
    "resourceAccountPlugin",
    "responseHandlerPlugin"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
